import React from "react";
import { Form, Select, Tag, Input, Typography } from "antd";
import { ApartmentOutlined, KeyOutlined } from "@ant-design/icons";

const { Text } = Typography;
const { Option } = Select;

const PermissionForm = ({
  form,
  currentPermission,
  resources,
  actions,
  resourceColors,
  actionColors,
  customResourceInput,
  setCustomResourceInput,
  customActionInput,
  setCustomActionInput,
}) => {
  return (
    <Form form={form} layout="vertical" className="mt-3">
      <Form.Item
        name="resource"
        label={
          <span className="flex items-center">
            <ApartmentOutlined className="mr-1 text-blue-500" />
            Resource
          </span>
        }
        rules={[{ required: true, message: "Please enter or select resource" }]}
      >
        <Select
          placeholder="Select a resource"
          allowClear
          showSearch
          dropdownRender={(menu) => (
            <>
              {menu}
              <div className="p-2 border-t">
                <Input
                  placeholder="Enter a new resource"
                  value={customResourceInput}
                  onChange={(e) => setCustomResourceInput(e.target.value)}
                  onPressEnter={() => {
                    if (customResourceInput && customResourceInput.trim() !== "") {
                      form.setFieldsValue({ resource: customResourceInput.trim() });
                    }
                  }}
                />
              </div>
            </>
          )}
          onSelect={() => setCustomResourceInput("")}
        >
          {resources.map((resource) => (
            <Option key={resource} value={resource}>
              <Tag color={resourceColors[resource]} className="mr-2">
                {resource}
              </Tag>
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="action"
        label={
          <span className="flex items-center">
            <KeyOutlined className="mr-1 text-green-500" />
            Action
          </span>
        }
        rules={[{ required: true, message: "Please enter or select action" }]}
      >
        <Select
          placeholder="Select an action"
          allowClear
          showSearch
          dropdownRender={(menu) => (
            <>
              {menu}
              <div className="p-2 border-t">
                <Input
                  placeholder="Enter a new action"
                  value={customActionInput}
                  onChange={(e) => setCustomActionInput(e.target.value)}
                  onPressEnter={() => {
                    if (customActionInput && customActionInput.trim() !== "") {
                      form.setFieldsValue({ action: customActionInput.trim() });
                    }
                  }}
                />
              </div>
            </>
          )}
          onSelect={() => setCustomActionInput("")}
        >
          {actions.map((action) => (
            <Option key={action} value={action}>
              <Tag color={actionColors[action]} className="mr-2">
                {action}
              </Tag>
            </Option>
          ))}
        </Select>
      </Form.Item>

      <div className="mt-4 p-3 bg-gray-50 rounded-md">
        <Text type="secondary">
          The permission will be represented as:{" "}
          <code className="text-sm bg-gray-100 px-2 py-1 rounded">
            {form.getFieldValue("resource") || customResourceInput || "resource"}.
            {form.getFieldValue("action") || customActionInput || "action"}
          </code>
        </Text>
      </div>
    </Form>
  );
};

export default PermissionForm;